var map = {
	"./cs.json": 2917,
	"./da.json": 4308,
	"./de.json": 3624,
	"./en-GB.json": 3910,
	"./en.json": 6660,
	"./es.json": 5571,
	"./fr-CA.json": 5878,
	"./fr.json": 4527,
	"./it.json": 2938,
	"./ja.json": 5986,
	"./ko.json": 6881,
	"./nl.json": 3821,
	"./no.json": 2128,
	"./pl.json": 5063,
	"./pt-BR.json": 5574,
	"./sv.json": 870,
	"./zh-Hans.json": 8728,
	"./zh-Hant.json": 8625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2680;